import React from "react";
import cn from "classnames";
import { MediaQuery } from "../technical/MediaQuery";
import { ActivatedFacets, Facet, OpenedFilterTabByFilterKey as OpenedFilterTabFilterKey } from "./types";
import { UpArrowSvg } from "../../../assets";
import { CSS_MQ } from "../../../styles/breakpoints";
import { css } from "@emotion/react";
import { FONTS, fontColor, fontSize } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { T } from "../../T";

type PlpFacetProps = React.PropsWithChildren<{
  facet: Facet;
  openedFilterTabByFilterKey: OpenedFilterTabFilterKey;
  activatedFacetsState: ActivatedFacets;
  onClick: () => void;
  showActiveFacet: boolean;
}>;

export const PLPFacet: React.FC<PlpFacetProps> = ({
  facet,
  openedFilterTabByFilterKey,
  activatedFacetsState: activeFacets,
  showActiveFacet,
  onClick,
  children,
}) => {
  const isOpened = openedFilterTabByFilterKey && openedFilterTabByFilterKey === facet.__key;

  const className = cn({
    opened: isOpened,
    "with-active-facet": showActiveFacet && !!activeFacets[facet.__key],
  });

  return (
    <div key={facet.__key} css={filterStyles} className={className}>
      <div className={cn("u-flex u-items-center")} onClick={onClick}>
        <UpArrowSvg css={arrowIconStyles} />

        <span className="label">
          <T>{facet.label}</T>
        </span>
      </div>

      {isOpened && <MediaQuery atMost={"sm"}>{children}</MediaQuery>}
    </div>
  );
};

const arrowIconStyles = css`
  width: 16px;
  height: 32px;
  color: black;

  margin-right: 9px;
  margin-bottom: 0;

  transition: transform 0.1s linear;

  transform: rotate(90deg);

  ${CSS_MQ.atLeastMd} {
    display: none;
  }

  .opened & {
    transform: rotate(180deg);
  }
`;

const filterStyles = [
  FONTS.SwarovskiFutura300,
  fontColor.black,
  fontSize.x2,
  css`
    ${CSS_MQ.atMostSm} {
      ${FONTS.SwarovskiFutura500};

      width: 100%;

      > div {
        display: flex;
      }

      svg {
        flex-shrink: 0;
      }
    }

    ${CSS_MQ.atLeastMd} {
      padding-left: 6px;
      padding-right: 6px;

      .label {
        padding-top: 4px;
        border-top: 2px solid transparent;

        padding-left: 6px;
        padding-right: 6px;
      }
    }

    text-transform: uppercase;

    &.opened,
    &:hover {
      color: ${CSS_COLORS.Green};
    }

    &.opened {
      ${CSS_MQ.atLeastMd} {
        .label {
          // border-top-color: ${CSS_COLORS.Green};
        }
        text-shadow:
          -0.06ex 0 ${CSS_COLORS.Green},
          0.06ex 0 ${CSS_COLORS.Green};
      }
    }

    .label {
      ${CSS_MQ.atLeastSm} {
        white-space: nowrap;
      }

      position: relative;
      display: inline-block;
    }

    &.with-active-facet {
      .label {
        &::before {
          position: absolute;
          content: "";

          border-radius: 50%;
          background-color: ${CSS_COLORS.Green};

          width: 8px;
          height: 8px;
          top: -5px;
          right: -8px;

          ${CSS_MQ.atLeastMd} {
            top: -3px;
            right: -4px;
          }
        }
      }
    }
  `,
];
